"use client";

import { Link } from "@/shared";
import {
  Breadcrumb,
  BreadcrumbAction,
  BreadcrumbItem,
} from "@dafiti/closet-ui";
import { useTranslations } from "next-intl";

export type CMSBreadcrumbProps = {
  title: string;
  href: string;
};

export function CMSBreadcrumb({ title, href }: Readonly<CMSBreadcrumbProps>) {
  const t = useTranslations("shared");
  return (
    // do not remove the classname because CMS applies a style to hide it when needed :l
    <Breadcrumb className="catalog-breadcrumb clearfix pt-4">
      <BreadcrumbItem>
        <BreadcrumbAction as={Link} href="/" useRouterLink>
          {t("breadcrumb.home")}
        </BreadcrumbAction>
      </BreadcrumbItem>
      <BreadcrumbItem isLast>
        <BreadcrumbAction as={Link} href={href} useRouterLink>
          {title}
        </BreadcrumbAction>
      </BreadcrumbItem>
    </Breadcrumb>
  );
}
